import { useEffect, useState } from "react";
import { LedgerRecord } from "../../../services/interface";
import { sanitizeSearchInput } from "../../../../shared/utils/searchUtils";
import { getLedger } from "src/shared/services/servicesv2";

export function useLedgerSearch(includeSettled: boolean = true) {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState<LedgerRecord[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const delay = setTimeout(async () => {
      const trimmedSearch = searchTerm.trim();

      if (!trimmedSearch) {
        setResults([]);
        return;
      }

      try {
        setLoading(true);

        // ✅ Fixed: Correct parameter order
        const res = await getLedger(
          1,                    // page
          20,                   // row/pageSize
          trimmedSearch,        // search
          "",                   // sortField
          "",                   // sortOrder
          includeSettled        // includeSettled
        );

        // Handle different response structures safely
        const ledgerData = res?.data?.result || res?.data?.results || res?.data?.data || [];

        setResults(Array.isArray(ledgerData) ? ledgerData : []);
      } catch (error) {
        console.error("Error fetching ledgers:", error);
        setResults([]);
      } finally {
        setLoading(false);
      }
    }, 500);

    return () => clearTimeout(delay);
  }, [searchTerm, includeSettled]); // ✅ Added includeSettled to dependencies

  const handleSearchChange = (value: string) => {
    const sanitizedValue = sanitizeSearchInput(value);
    setSearchTerm(sanitizedValue);
  };

  return {
    searchTerm,
    results,
    loading,
    setSearchTerm: handleSearchChange,
  };
}